import React from 'react';
import { apc, secondaryButton } from '../motivated-skills/theme';
import { readLaunchState } from '../../lib/launch';

// S5b.4: the way back from a finished assessment to the client's journey.
// Shown only in a tab opened by /launch, and only to the launch's own
// `returnTo` (checked by the server against the portal's origins at mint and
// again at redeem). Anywhere else it renders nothing, so today's finish
// screens are unchanged.

export default function BackToJourney({ tone = 'light' }) {
  const launch = readLaunchState();
  const href = launch && typeof launch.returnTo === 'string' ? launch.returnTo : null;
  if (!href) return null;
  const onDark = tone === 'dark';
  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '16px 20px 32px' }}>
      <a
        href={href}
        data-testid="back-to-journey"
        style={
          onDark
            ? {
                // The Constellation's cosmic results page: as S5b.4 drew it.
                display: 'inline-block',
                fontFamily: apc.body,
                fontSize: 16,
                fontWeight: 700,
                color: apc.navy,
                background: '#fff',
                borderRadius: 12,
                padding: '12px 24px',
                textDecoration: 'none',
              }
            : // S5a.8: the light finish screens take the contract's secondary, a hairline.
              { ...secondaryButton, display: 'inline-block' }
        }
      >
        Back to your journey
      </a>
    </div>
  );
}
